import type { PolicySeverity } from "@repo/api/schemas/policies.schema";
import { createColumn, getSortOptions } from "@repo/mfe-core";
import { ChipColorTypes } from "@saviynt/design-system";
import type { IntlShape } from "react-intl";

export const tableColumns = [
  createColumn("name", "Policy Name", "35rem", { isPinned: true }),
  createColumn("severity", "Severity", "10rem"),
  createColumn("attribution_count", "Findings", "5rem", { isSortable: false }),
  createColumn("tags", "Tags", "15rem", { isSortable: false }),
  createColumn("is_active", "Enabled", "8rem", { isSortable: false }),
  createColumn("actionColumn", "actionColumn", "min-content", {
    isPinned: true,
    isColumnConfigEnabled: true,
  }),
];

const sortableColumns = ["name", "severity"];

export const getSortConfigs = (intl: IntlShape) =>
  sortableColumns.map((key) => ({ key, sortOptions: getSortOptions(intl) }));

const severityColorMap: Record<PolicySeverity, ChipColorTypes> = {
  critical: "critical",
  high: "orange",
  medium: "warning",
  low: "success",
};

export const getPoliciesColor = (severity: PolicySeverity): ChipColorTypes =>
  severityColorMap[severity] ?? "success";
